module.exports = __webpack_public_path__ + "static/3-cc35f41dc9ef9845067097579028128f.png";